var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-listing__switch align-self-center" },
    [
      _c(
        "span",
        {
          staticClass: "product-listing__switch--list",
          class: { "text-primary": _vm.active === "list" },
          on: {
            click: function ($event) {
              return _vm.setLayout("list")
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "15",
              },
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#svg-list-view",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "product-listing__switch--tiles",
          class: { "text-primary": _vm.active === "tiles" },
          on: {
            click: function ($event) {
              return _vm.setLayout("tiles")
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "15",
              },
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#svg-tile-view",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }